import React, { useState } from 'react';
import {
  Box,
  Drawer,
  List,
  Typography,
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip
} from '@mui/material';
import {
  Menu as MenuIcon,
  Dashboard as DashboardIcon,
  Folder as ProjectsIcon,
  CalendarToday as PlanningIcon,
  Assignment as TasksIcon,
  ViewKanban as BoardIcon,
  Help as HelpIcon
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import html2canvas from 'html2canvas';
import SupportModal from '../Support/SupportModal';

const menuItems = [
  { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' },
  { text: 'Boards', icon: <BoardIcon />, path: '/boards' },
  { text: 'Projects', icon: <ProjectsIcon />, path: '/projects' },
  { text: 'Planning', icon: <PlanningIcon />, path: '/planning' },
  { text: 'Tasks', icon: <TasksIcon />, path: '/tasks' }
];

const Sidebar = ({
  mobileOpen,
  handleDrawerToggle,
  drawerCollapsed,
  setDrawerCollapsed,
  drawerWidth,
  collapsedDrawerWidth
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showSupportModal, setShowSupportModal] = useState(false);
  const [screenShotFileData, setScreenShotFileData] = useState(null);

  const handleSupportClick = () => {
    html2canvas(document.body, {
      useCORS: true,
      allowTaint: true,
      scale: 0.5
    }).then(canvas => {
      const dataURL = canvas.toDataURL('image/jpeg', 0.8)
      setScreenShotFileData(dataURL)
      setShowSupportModal(true)
    }).catch(error => {
      console.error('Error capturing screenshot:', error)
      setScreenShotFileData('data:image/jpeg;base64,')
      setShowSupportModal(true)
    })
  }

  const handleCloseSupportModal = () => {
    setShowSupportModal(false)
    setScreenShotFileData(null)
  }

  const drawer = (
    <div>
      <Box sx={{ height: 64, display: 'flex', alignItems: 'center' }}>
        <ListItemButton
          onClick={() => setDrawerCollapsed(!drawerCollapsed)}
          sx={{
            justifyContent: drawerCollapsed ? 'center' : 'initial',
            height: '100%'
          }}
        >
          <ListItemIcon sx={{ minWidth: drawerCollapsed ? 0 : 56 }}>
            <MenuIcon />
          </ListItemIcon>
          {!drawerCollapsed && (
            <Box sx={{ display: 'flex', flexDirection: 'column', margin: '4px 4px', alignItems: 'center' }}>
              <img
                src="/dark_logo_transparent.png"
                alt="weldinGo"
                style={{ height: '49.92px', marginRight: '4px' }}
              />
              <Typography variant="h6" sx={{ fontSize: '0.7rem', fontWeight: 'bold', textTransform: 'uppercase', lineHeight: '1' }}>
                PROJECTS
              </Typography>
            </Box>
          )}
        </ListItemButton>
      </Box>
      <Divider />
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <Tooltip title={drawerCollapsed ? item.text : ''} placement="right" arrow>
              <ListItemButton
                selected={location.pathname === item.path}
                onClick={() => navigate(item.path)}
                sx={{ justifyContent: drawerCollapsed ? 'center' : 'initial' }}
              >
                <ListItemIcon sx={{ minWidth: drawerCollapsed ? 0 : 56 }}>
                  {item.icon}
                </ListItemIcon>
                {!drawerCollapsed && <ListItemText primary={item.text} />}
              </ListItemButton>
            </Tooltip>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        <ListItem disablePadding>
          <Tooltip title={drawerCollapsed ? 'Support' : ''} placement="right" arrow>
            <ListItemButton
              onClick={handleSupportClick}
              sx={{ justifyContent: drawerCollapsed ? 'center' : 'initial' }}
            >
              <ListItemIcon sx={{ minWidth: drawerCollapsed ? 0 : 56 }}>
                <HelpIcon />
              </ListItemIcon>
              {!drawerCollapsed && <ListItemText primary="Support" />}
            </ListItemButton>
          </Tooltip>
        </ListItem>
      </List>
    </div>
  );

  return (
    <>
      <Box
        component="nav"
        sx={{ width: { sm: drawerCollapsed ? collapsedDrawerWidth : drawerWidth }, flexShrink: { sm: 0 } }}
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerCollapsed ? collapsedDrawerWidth : drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerCollapsed ? collapsedDrawerWidth : drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      {showSupportModal && (
        <SupportModal
          onCancel={handleCloseSupportModal}
          screenShotFileData={screenShotFileData}
        />
      )}
    </>
  );
};

export { menuItems };
export default Sidebar;
